import { setRecoil } from 'recoil-nexus';

import { myScribeAcknowledged } from 'components/practice/charts/ClinicalNote/MyScribeAI/state';

export default () => {
  setRecoil(myScribeAcknowledged, true);
};
